import react from "react";
import { Select } from "antd";

const LocationFilter = ({ locationOptions, locationSearch, handleLocationChange, includeUnassignedOption }) => {
    return (
        <Select
            value={locationSearch || ""}
            onChange={(e) => handleLocationChange(e)}
            className="me-2"
            style={{ width: 200 }}
            showSearch
            filterOption={(input, option) => {
                // Fix 5: Better filter logic
                return (option?.children ?? "")
                    .toString()
                    .toLowerCase()
                    .includes(input.toLowerCase());
            }}
            allowClear
        >
            {includeUnassignedOption && (
                <Select.Option key="unassigned" value="unassigned">Unassigned Location</Select.Option>
            )}
            {locationOptions.map((location) => (
                <Select.Option key={location.id} value={location.id}>{location.name}</Select.Option>
            ))}
        </Select>
    )
};

export default LocationFilter;